import { useSelector } from "react-redux";
import { Table, TableCell, TableBody, TableRow } from "../ui/table";
import { clientSelector } from "@/redux/clients/clients.selector";
import { Typography } from "@mui/material";
import InvoicingDataPage from "./InvoicingData/page";
import ComercialInvoicingPage from "./ComercialInvoicing/page";
import DuaDocumentsPage from "./DuaDocuments/page";
import LiquidationsPage from "./Liquidations/page";

export const FolderDataTable = () => {
  const { folderData } = useSelector(clientSelector).ui;

  const colorLabel = {
    V: {
      textColor: "text-green-500",
      label: "Verde",
      backgroundColor: "bg-green-50",
    },
    R: {
      textColor: "text-red-500",
      label: "Rojo",
      backgroundColor: "bg-red-50",
    },
    N: {
      textColor: "text-orange-500",
      label: "Naranja",
      backgroundColor: "bg-orange-50",
    },
    "": {
      textColor: "text-gray-500",
      label: "- - -",
      backgroundColor: "bg-gray-50",
    },
  };

  const handleNewDate = (date: Date) => {
    return new Date(date).toLocaleDateString();
  };

  return (
    <div>
      {folderData && folderData.carpetas.length > 0 && (
        <div>
          <Typography
            fontFamily={"Inter"}
            fontSize={"18px"}
            fontWeight={500}
            className="py-2"
          >
            Datos de la carpeta
          </Typography>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell className="font-medium bg-gray-100 w-[50%]">
                  Aduana
                </TableCell>
                <TableCell>
                  {folderData?.carpetas[0].dua.aduanaOrigen || "- - -"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium bg-gray-100 w-[50%]">
                  Número de DUA
                </TableCell>
                <TableCell>{folderData?.carpetas[0].dua.nroDua}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium bg-gray-100 w-[50%]">
                  Canal
                </TableCell>
                <TableCell>
                  <span
                    className={`${
                      colorLabel[
                        folderData?.carpetas[0].dua
                          .canal as keyof typeof colorLabel
                      ].textColor
                    } ${
                      colorLabel[
                        folderData?.carpetas[0].dua
                          .canal as keyof typeof colorLabel
                      ].backgroundColor
                    } px-2 py-1 rounded-md`}
                  >
                    {
                      colorLabel[
                        folderData?.carpetas[0].dua
                          .canal as keyof typeof colorLabel
                      ].label
                    }
                  </span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium bg-gray-100 w-[50%]">
                  Fecha de Numerado
                </TableCell>
                <TableCell>
                  {folderData?.carpetas[0].dua.fechaNumerado
                    ? handleNewDate(folderData?.carpetas[0].dua.fechaNumerado)
                    : "- - -"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium bg-gray-100 w-[50%]">
                  Proveedor / Destinatario
                </TableCell>
                <TableCell>
                  {folderData?.carpetas[0].dua.proveedor || "- - -"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium bg-gray-100 w-[50%]">
                  ID único
                </TableCell>
                <TableCell>
                  {folderData?.carpetas[0].correlativo || "- - -"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium bg-gray-100 w-[50%]">
                  Carpeta
                </TableCell>
                <TableCell>
                  {folderData?.carpetas[0].numeroCarpeta || "- - -"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium bg-gray-100 w-[50%]">
                  Referencia
                </TableCell>
                <TableCell>
                  {folderData?.carpetas[0].refCliente
                    ? folderData?.carpetas[0].refCliente
                    : "- - -"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      )}
      <div className="flex flex-col mt-4 min-w-full">
        <Typography fontFamily={"Inter"} fontSize={"18px"} fontWeight={500}>
          Facturas de la carpeta
        </Typography>
        <InvoicingDataPage />
        <Typography fontFamily={"Inter"} fontSize={"18px"} fontWeight={500}>
          Facturas Comerciales
        </Typography>
        <ComercialInvoicingPage />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 w-full">
          <div className="flex flex-col">
            <Typography fontFamily={"Inter"} fontSize={"18px"} fontWeight={500}>
              Documentos No Comerciales
            </Typography>
            <DuaDocumentsPage />
          </div>
          <div className="flex flex-col">
            <Typography fontFamily={"Inter"} fontSize={"18px"} fontWeight={500}>
              Liquidaciones
            </Typography>
            <LiquidationsPage />
          </div>
        </div>
      </div>
    </div>
  );
};
